<section class="d-flex align-items-center gap-2 card-delivery-date card-delivery-date--bg-green">
    @if (!hasMinOrder()) {
    <span class="material-symbols-outlined text-primary animated fadeInLeft">
        error_outline
    </span>
    } @else if (enableFreeDeliveryThreshold()) {
    @if (!orderDeliveryFee()) {
    <span class="material-symbols-outlined text-primary animated fadeInLeft">
        check_circle
    </span>
    } @else {
    <span class="material-symbols-outlined text-primary animated fadeInLeft">
        add_shopping_cart
    </span>
    }
    } @else {
    @if (orderDeliveryFee() && hasDeliveryFeeRange() && !currentSliderInfo().isLast) {
    <span class="material-symbols-outlined text-primary animated fadeInLeft">
        add_shopping_cart
    </span>
    } @else {
    <span class="material-symbols-outlined text-primary animated fadeInLeft">
        check_circle
    </span>
    }
    }

    <section class="d-flex flex-column flex-grow-1 gap-1">
        <small class="h8-regular text-black text-center">
            @if(!hasMinOrder()) {
            You haven't reached the <b>({{minOrder() | currency}})</b> order minimum required for delivery.
            } @else if (enableFreeDeliveryThreshold()){
            @if (orderDeliveryFee()) {
            Your delivery fee is now <b>{{orderDeliveryFee() | currency}}</b>
            @if(enableFreeDeliveryThreshold()) {
            <p class="m-0">Add <b>{{minOrderDiffForFreeDelivery() | currency}}</b> for Free Delivery.</p>
            }
            }@else {
            You've unlocked Free Delivery!
            }
            } @else {
            @if (currentSliderInfo().isLast) {
            @if (currentSliderInfo().amount && !hasDeliveryFeeRange()) {
            You’ve reached the minimum for delivery.
            }@else if (hasDeliveryFeeRange() && orderDeliveryFee()) {
            Great! Your delivery fee is now <b>{{orderDeliveryFee() | currency}}</b>.
            } @else {
            You've unlocked Free Delivery!
            }
            } @else if (!currentSliderInfo().amount && !currentSliderInfo().isMinOrder) {
            <p class="m-0">Your delivery fee is now <b>{{orderDeliveryFee() | currency}}</b>. </p>
            <p class="m-0">Add <b>{{minOrderDiffForFreeDelivery() | currency}}</b> for Free Delivery.</p>
            } @else {
            <p class="m-0">Your delivery fee is now <b>{{orderDeliveryFee() | currency}}</b>. </p>
            <p class="m-0">Add
                <b>{{minOrderDiffForFreeDelivery() | currency}}</b> to get a delivery fee of
                <b>{{currentSliderInfo().amount | currency}}</b>.
            </p>
            }
            }
        </small>

        <mat-progress-bar mode="determinate" [value]="percentMinSpend()"
            [color]="progressBarColor()"></mat-progress-bar>
    </section>

    <small class="h8-bold text-black flex-shrink-0 goal-content" [class.goal-content-sm]="currentSliderInfo().isLast">
        @if ((enableFreeDeliveryThreshold() || hasDeliveryFeeRange()) && hasMinOrder()) {
        {{ currentSliderInfo().minSpend | currency }}
        } @else {
        {{ minOrder() | currency }}
        }
    </small>

</section>